import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const uploadManagerContext = createContext(undefined);
export default function useUploadManager() {
    const uploadManager = useContext(uploadManagerContext);
    if (uploadManager === undefined) {
        throw new Error('useUploadManager must be used within a UploadManagerProvider');
    }
    return uploadManager;
}
export function UploadManagerProvider(props) {
    const { uploadManager, children } = props;
    return _jsx(uploadManagerContext.Provider, { value: uploadManager, children: children });
}
//# sourceMappingURL=UseUploadManager.js.map